import { render, staticRenderFns } from "./RedesignTeamDetails.vue?vue&type=template&id=cea64bb4&scoped=true"
import script from "./RedesignTeamDetails.vue?vue&type=script&lang=js"
export * from "./RedesignTeamDetails.vue?vue&type=script&lang=js"
import style0 from "./RedesignTeamDetails.vue?vue&type=style&index=0&id=cea64bb4&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"
import style1 from "./RedesignTeamDetails.vue?vue&type=style&index=1&id=cea64bb4&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cea64bb4",
  null
  
)

export default component.exports